import './scss/main.scss';
import '@splidejs/splide/css';

import {createApp} from 'vue'
import App from '@/App.vue'
import {createPinia} from "pinia";
import router from "@/router";
import i18n from "@/plugins/i18n";
import {initWagmi, wagmiAdapter} from "@/plugins/wallet/wagmi.js";
import {WagmiPlugin} from "@wagmi/vue";
import {useAuth} from "@/stores/auth.js";

import * as Sentry from "@sentry/vue";

window.appkit = initWagmi();

await initBootstrapComponents();

const app = createApp(App);
const pinia = createPinia();
if (!import.meta.env.VITE_DEBUG) {
    Sentry.init({
        app,
        dsn: "https://7bbfe5562be2f92e0e8c66a7e11bdb07@sentry.zelmalab.com/10",
        integrations: [
            Sentry.browserTracingIntegration({router}),
            Sentry.replayIntegration()
        ],
        // Tracing
        tracesSampleRate: 1.0, // Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/dev\.lend7\.com/, /^https:\/\/dev-api\.lend7\.com/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

app.use(WagmiPlugin, {config: wagmiAdapter.wagmiConfig});
app.use(pinia);
app.use(router);

await i18n(app);

const authStore = useAuth();
await authStore.loadUser();

app.mount('#app');


async function initBootstrapComponents() {
    // if (typeof window !== 'undefined') {
    // const Bootstrap = await import('bootstrap/dist/js/bootstrap.bundle.js');
    // window.Dropdown = await import('bootstrap/js/src/dropdown.js');
    window.Collapse = await import('bootstrap/js/src/collapse.js');
    // }
}
